module.exports = __webpack_public_path__ + "img/share-06.fcaa193c.svg";